type Primitive = string | number | boolean | bigint | symbol;

type PrimitiveKeys<T> = {
  [K in keyof T]: T[K] extends Primitive ? K : never;
}[keyof T];

export function filter<T extends Primitive>(value: string, list: T[]): T[];

export function filter<T extends Record<string, unknown>>(
  value: string,
  list: T[],
  param: PrimitiveKeys<T>,
): T[];

export function filter<T>(value: string, list: T[], param?: keyof T) {
  if (!value.trim()) return list;

  if (param) {
    return list.filter((item) =>
      String(item[param]).toLowerCase().includes(value.toLowerCase()),
    );
  }

  return list.filter((item) =>
    String(item).toLowerCase().includes(value.toLowerCase()),
  );
}
